/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpellingCorrectionFeature
 */
export interface SpellingCorrectionFeature {
    /**
     * 
     * @type {string}
     * @memberof SpellingCorrectionFeature
     */
    suggestion: string;
}

/**
 * Check if a given object implements the SpellingCorrectionFeature interface.
 */
export function instanceOfSpellingCorrectionFeature(value: object): value is SpellingCorrectionFeature {
    if (!('suggestion' in value) || value['suggestion'] === undefined) return false;
    return true;
}

export function SpellingCorrectionFeatureFromJSON(json: any): SpellingCorrectionFeature {
    return SpellingCorrectionFeatureFromJSONTyped(json, false);
}

export function SpellingCorrectionFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpellingCorrectionFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestion': json['suggestion'],
    };
}

export function SpellingCorrectionFeatureToJSON(value?: SpellingCorrectionFeature | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestion': value['suggestion'],
    };
}

